import { apiClient } from '../client';
import { API_ENDPOINTS } from '../constant/endpoints';
import type { IApiResponse, IPaginatedResponse } from '../types';
import type {
    ICreateRoleInput,
    IRole,
    IRoleMemberSummary,
    IRolesListQuery,
    IRoleWithPermissions,
    IUpdateRoleInput,
} from '@/features/users-roles/interfaces';

export const rolesApi = {
    list: (params: IRolesListQuery = {}) =>
        apiClient
            .get<IApiResponse<IRole[]> & { meta: IPaginatedResponse<IRole> }>(
                API_ENDPOINTS.ROLE.LIST,
                {
                    params: {
                        page: params.page ?? 1,
                        limit: params.limit ?? 40,
                        excludeOwner: params.excludeOwner,
                    },
                },
            )
            .then((r) => ({
                data: r.data.data,
                page: r.data.meta.page,
                limit: r.data.meta.limit,
                total: r.data.meta.total,
                totalPages: r.data.meta.totalPages,
            })),

    getById: (id: string) =>
        apiClient
            .get<IApiResponse<IRoleWithPermissions>>(API_ENDPOINTS.ROLE.BY_ID(id))
            .then((r) => r.data.data),

    create: (dto: ICreateRoleInput) =>
        apiClient.post<IApiResponse<IRole>>(API_ENDPOINTS.ROLE.LIST, dto).then((r) => r.data.data),

    update: (id: string, dto: IUpdateRoleInput) =>
        apiClient
            .patch<IApiResponse<IRole>>(API_ENDPOINTS.ROLE.BY_ID(id), dto)
            .then((r) => r.data.data),

    remove: (id: string) =>
        apiClient.delete<IApiResponse<null>>(API_ENDPOINTS.ROLE.BY_ID(id)).then((r) => r.data.data),

    listMembers: (id: string) =>
        apiClient
            .get<IApiResponse<IRoleMemberSummary[]>>(API_ENDPOINTS.ROLE.MEMBERS(id))
            .then((r) => r.data.data),

    getMyPermissions: () =>
        apiClient
            .get<IApiResponse<{ permissions: string[] }>>(API_ENDPOINTS.ROLE.MY_PERMISSIONS)
            .then((r) => r.data.data.permissions),
};
